import { render, staticRenderFns } from "./RFPView.vue?vue&type=template&id=3578bcd1&"
import script from "./RFPView.vue?vue&type=script&lang=js&"
export * from "./RFPView.vue?vue&type=script&lang=js&"
import style0 from "./RFPView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports